import React from 'react';
import { useRouter } from 'next/router';
import Link from '../../../Link';
import { categoryColor } from '../shared';
import { toTitleCase } from '~/utils/stringUtils';
import { ArrowIcon } from '../ArticleSnippet';

interface TagsListProps {
  tags: string[];
}

export function TagsList({ tags }: TagsListProps) {
  const router = useRouter();
  const pathToUse = router.asPath;
  const pathSlugs = pathToUse.split('/').filter((slug) => slug !== '');
  const basePath = `/${pathSlugs.shift()}`;

  return tags.length === 0 ? null : (
    <div className="flex flex-wrap desktop:mt-6" data-testid="blog-tags-list">
      {tags.map((tag, index) => {
        // For the first tab (article category) we link to its page, for other tags we navigate to base path
        const path = (
          index == 0 ? basePath + `/${tag.toLowerCase()}` : basePath
        ).replaceAll(' ', '-');

        return (
          <span
            key={tag}
            className="group/button relative flex w-fit items-center rounded-full px-[6px] py-[2px] text-xs font-medium leading-4"
            style={{
              background:
                categoryColor[tag.toLowerCase().replace(' ', '-') || 'popular']
            }}
          >
            <Link href={path}>{toTitleCase(tag)}</Link>
            <ArrowIcon className="ml-1 hidden transition-all duration-300 group-hover/button:block" />
          </span>
        );
      })}
    </div>
  );
}
